module.exports = __webpack_public_path__ + "static/media/badgeIcon.8f8a4fed.svg";